import React, { useEffect, useMemo, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Navigation, Pagination } from "swiper/modules";
import {
  analyticsEventTypes,
  parseCssStringToObject,
} from "../../../../helper";
import { DEFAULT_BLOCK_CSS } from "../../../../constant/constant";
import { useApp } from "../../../../context/AppState";
import cartService from "../../../../services/cart.service";
import { useAnalytics } from "../../../../hooks/useAnalytics";
import Loader from "../Loader";
import getSymbolFromCurrency from "currency-symbol-map";
import ViewTabIcon from "../../../../assets/noun-new-tab-6294363.svg";
import soundOn from "../../../../assets/sound-on.svg";
import soundOff from "../../../../assets/sound-off.svg";

const SliderBlock = ({ popupData, section, handleClose, popupState, setPopupState }) => {
  const storeName = (window?.Shopify?.shop || window.location.hostname).replace(
    ".myshopify.com",
    ""
  );
  const { isMobile, appState } = useApp();
  const [isMuted, setIsMuted] = useState(false);

  const popupType = useMemo(() => popupData?.popUpType, [popupData]);
  const popupId = useMemo(() => popupData?._id, [popupData]);
  
  const currencySymbol = appState?.is_preview_mode
    ? getSymbolFromCurrency(appState?.shop?.currency)
    : getSymbolFromCurrency(window?.Shopify?.currency?.active);

  const [isLoading, setIsLoading] = useState(false);
  const swiperRef = useRef(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const [activeIndex, setActiveIndex] = useState(localStorage.getItem("sliderActiveIndex") ?? 0);
  const videos = section.sections || [];
  const blockCSS = {
    ...DEFAULT_BLOCK_CSS,
    ...section?.setting?.customCSS?.[isMobile ? "mobile" : "desktop"],
    ...parseCssStringToObject(
      section?.setting?.overrideCss?.[isMobile ? "mobile" : "desktop"]
    ),
  };

  const videoRefs = useRef([]);

  const Slider_theme = section?.setting?.theme;

  const getSlidePerViewSlide = () => {
    switch (Slider_theme) {
      case "theme_1":
      default: {
        if (isMobile) {
          return 1;
        }
        return 3;
      }
      case "theme_2":
        if (isMobile || (!appState?.is_preview_mode && window.innerWidth <= 600)) {
          return 1;
        }
        if (!appState?.is_preview_mode && window.innerWidth <= 900) {
          return Math.round(Number(section?.setting?.slidesPerView) / 2) || 2;
        }
        return Number(section?.setting?.slidesPerView) || 3;
    }
  };

  const getInitialSlide = () => {
    if(localStorage.getItem("sliderActiveIndex")){
      return localStorage.getItem("sliderActiveIndex")
    }
    switch (Slider_theme) {
      case "theme_1":
      default:
        return 0;
      case "theme_2":
        const slidesPerView = getSlidePerViewSlide();
        if (window.innerWidth <= 600) {
          return 0;
        }
        if (slidesPerView <= 4) {
          return 1;
        }
        if (slidesPerView <= 6) {
          return 2;
        }
        return 0;
    }
  };
  useEffect(() => {
    if (swiperInstance) {
      swiperInstance.slideTo(getInitialSlide(), 0);
    }
  }, [swiperInstance]);

  useEffect(() => {
    // Don't autoplay videos in preview mode
    if (appState?.is_preview_mode) {
      return;
    }
    
    requestAnimationFrame(() => {
      videoRefs.current.forEach((video, index) => {
        if (video) {
          if (index === activeIndex) {
            video
              .play()
              .catch((error) => console.warn("Video play failed:", error));
          } else {
            video.pause();
          }
        }
      });
    });
  }, [activeIndex, appState?.is_preview_mode]);

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
  };


  const handleStepChange = () => {
    localStorage.setItem("sliderActiveIndex", swiperInstance?.activeIndex);
    setPopupState((prev) => ({
      ...prev,
      [`${popupType}_${popupId}`]: {
        ...prev[`${popupType}_${popupId}`],
        activeStep: 1,
        openPopup: true,
        isEmbeded: false
      },
    }));
  }

  useEffect(() => {
    if (popupType === "Video Slider" && popupState?.activeStep !== 1) {
      setIsMuted(true);
    }
  }, [popupType, popupState]);

  const buttonStyle = {
    position: "absolute",
    zIndex: "10",
    background: "black",
    padding: "0",
    width: "40px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    outline: "none",
    transition: "background 0.2s ease",
    borderRadius: "3px",
  };
  return (
    <div
      style={{
        ...blockCSS,
        // pointerEvents: appState?.is_preview_mode ? "none" : "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      {videos.length > 0 ? (
        <>
          {Slider_theme === "theme_1" ? (
            <style jsx>{`
              .main-swiper {
                perspective: 1000px; /* Set the depth for the 3D effect */
              }

              .main-swiper > .swiper-wrapper {
                display: flex;
                align-items: center;
                transition: transform 0.5s ease; /* Smooth transition when rotating */
              }
              .main-swiper > .swiper-wrapper > .swiper-slide {
                z-index: 0;
                height: 65% !important;
                transition: height 300ms ease, width 300ms ease, z-index 0s !important;
              }

              /* Mobile View */
              ${videos.length <= 1 || isMobile
                ? `
                .main-swiper > .swiper-wrapper > .swiper-slide {
                  width: 100% !important;
                  height: 100% !important;
                  transform: none !important;
                }
              `
                : `
                .main-swiper > .swiper-wrapper > .swiper-slide-prev {
                  z-index: 0;
                  height: 65% !important;
                  width: 30% !important;
                  transform: translateX(30%) !important; /* Add 3D rotation */
                  transition: height 300ms ease, width 300ms ease, z-index 0s !important;
                }
  
                .main-swiper > .swiper-wrapper > .swiper-slide-prev .innnr-swiper {
                  display: none;
                }
  
                .main-swiper > .swiper-wrapper > .swiper-slide-active {
                  z-index: 2; /* Ensure the active slide is on top */
                  height: 100% !important;
                  width: 40% !important;
                  transition: height 300ms ease, width 300ms ease, z-index 0s !important;
                }
  
                .main-swiper > .swiper-wrapper > .swiper-slide-next {
                  z-index: 0;
                  height: 65% !important;
                  width: 30% !important;
                  transform:  translateX(-30%) !important; /* Add 3D rotation */
                  transition: height 300ms ease, width 300ms ease, z-index 0s !important;
                }
  
                .main-swiper > .swiper-wrapper > .swiper-slide-next .innnr-swiper {
                  display: none;
                }
              `}
            `}</style>
          ) : (
            <></>
          )}
          {!isMobile && videos.length > 1 && (
            <>
              {swiperInstance?.activeIndex !== 0 && (
                <button
                  onClick={() => swiperInstance?.slidePrev()}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#2f2f2f")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "black")
                  }
                  style={{
                    ...buttonStyle,
                    left: "0",
                  }}
                >
                  <svg
                    width="60"
                    height="80"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                  >
                    <path d="M15 18l-6-6 6-6" />
                  </svg>
                </button>
              )}
              {section.sections.length !== swiperInstance?.activeIndex + 1 && (
                <button
                  onClick={() => swiperInstance?.slideNext()}
                  style={{
                    ...buttonStyle,
                    right: "0",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#2f2f2f")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "black")
                  }
                >
                  <svg
                    width="60"
                    height="80"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </button>
              )}
            </>
          )}

          <Swiper
            ref={swiperRef}
            onSwiper={setSwiperInstance}
            modules={[Navigation, Pagination, Mousewheel]}
            centerInsufficientSlides={true}
            initialSlide={getInitialSlide()}
            centeredSlides={true}
            direction={
              Slider_theme === "theme_2"
                ? isMobile ||
                  (!appState?.is_preview_mode && window.innerWidth <= 600)
                  ? "vertical"
                  : "horizontal"
                : isMobile
                ? "vertical"
                : "horizontal"
            }
            slidesPerView={getSlidePerViewSlide()}
            spaceBetween={
              Slider_theme === "theme_2"
                ? section?.setting?.spaceBetween
                : undefined
            }
            mousewheel={true}
            onSlideChange={handleSlideChange}
            className="main-swiper"
            style={{
              ...blockCSS,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {section?.sections.map((section, index) => (
              <SwiperSlide
                key={index}
                style={{
                  ...blockCSS,
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  border: "none !important",
                  transform: Slider_theme === "theme_2" ? "scale(0.98)" : "",
                  transition: "all 0.1s ease-in-out",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform =
                    Slider_theme === "theme_2" ? "scale(1)" : "";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform =
                    Slider_theme === "theme_2" ? "scale(0.98)" : "";
                }}
              >
                <video
                  ref={(el) => (videoRefs.current[index] = el)}
                  style={{
                    height: "100%",
                    width: "100%",
                    borderRadius: "10px",
                    cursor: "grab",
                    objectFit: "cover",
                  }}
                  src={section?.src?.video}
                  title={`Video ${index + 1}`}
                  controls={section?.setting?.isControls}
                  autoPlay={index === activeIndex && !appState?.is_preview_mode}
                  muted={isMuted}
                  loop={section?.setting?.isLoop}
                  onClick={() => {
                    if (index === activeIndex) {
                      setIsMuted((prev) => !prev);
                    }
                    if (swiperRef.current && swiperRef.current.swiper) {
                      swiperRef.current.swiper.slideTo(index);
                    }
                    if(popupType === "Video Slider" && popupState?.activeStep === 0 && !appState?.is_preview_mode){
                      handleStepChange();
                    }
                  }}
                ></video>
                {index === activeIndex && (
                  <img
                    src={
                      isMuted
                      ? "https://pub-bf6c83729841477e8edf540e43c2a97f.r2.dev/sound-off_1741672616057.png"
                      : "https://pub-bf6c83729841477e8edf540e43c2a97f.r2.dev/sound-on_1741672593872.png"
                    }
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      width: "15px",
                      height: "15px",
                      borderRadius: "50%",
                      padding: "5px",
                      backgroundColor: "rgba(0,0,0,0.4)",
                    }}
                    onClick={() => {
                      if (index === activeIndex) {
                        setIsMuted((prev) => !prev);
                      }
                    }}
                  />
                )}
                <div
                  style={{
                    position: "absolute",
                    bottom: "0",
                    padding: "10px",
                    width: "90%",
                    zIndex: "200",
                  }}
                  className="innnr-swiper"
                >
                  <Swiper
                    modules={[Pagination]}
                    slidesPerView={1}
                    spaceBetween={10}
                    style={{
                      borderRadius: "10px",
                    }}
                  >
                    {section?.products?.map((product, productIndex) => (
                      <SwiperSlide key={product.id} style={{ height: "100%" }}>
                        <div
                          key={productIndex}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            backgroundColor: "rgba(255, 255, 255, 0.2)",
                            width: "100%",
                            backdropFilter: "blur(1.3)",
                            position: "relative",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              gap: "5px",
                              textAlign: "start !important",
                            }}
                          >
                            <img
                              src={product?.image?.src}
                              alt={"product image"}
                              style={{
                                maxHeight: "100px",
                                maxWidth: "100px",
                                width: "100%",
                              }}
                            />
                            <div>
                              <p
                                style={{
                                  margin: "5px 0 0 0",
                                  textAlign: "start",
                                  color: "white",
                                }}
                              >
                                {product.title}
                              </p>
                              <div>
                                <p
                                  style={{
                                    background: "white",
                                    borderRadius: "20px",
                                    padding: "0px 10px",
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    width: "fit-content",
                                  }}
                                >
                                  {currencySymbol} {product.variants[0]?.price}
                                  {/* <span
                                    style={{
                                      textDecoration: "line-through",
                                      color: "gray",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    {currencySymbol}{product.variants[0]?.price}
                                  </span> */}
                                </p>
                              </div>
                            </div>
                          </div>
                          <button
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              width: "100%",
                              border: "none",
                              cursor: "pointer",
                              padding: "8px",
                              backgroundColor: "#fff",
                              pointerEvents: appState?.is_preview_mode
                                ? "none"
                                : "auto",
                            }}
                            onClick={() =>
                              (window.location.href = `https://${storeName}.myshopify.com/products/${product.handle}`)
                            }
                          >
                            {isLoading ? (
                              <Loader />
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <p
                                  style={{
                                    margin: "0px",
                                  }}
                                >
                                  View Product
                                </p>
                                <div
                                  style={{
                                    width: "15px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-name="Layer 2"
                                    viewBox="0 0 24 24"
                                    x="0px"
                                    y="0px"
                                  >
                                    <defs>
                                      <style></style>
                                    </defs>
                                    <path
                                      class="cls-1"
                                      d="m21,12v6c0,1.6543-1.3457,3-3,3H6c-1.6543,0-3-1.3457-3-3V6c0-1.6543,1.3457-3,3-3h6c.55273,0,1,.44775,1,1s-.44727,1-1,1h-6c-.55176,0-1,.44873-1,1v12c0,.55127.44824,1,1,1h12c.55176,0,1-.44873,1-1v-6c0-.55225.44727-1,1-1s1,.44775,1,1Zm-1-9h-4c-.55273,0-1,.44775-1,1s.44727,1,1,1h1.58594l-9.29297,9.29297c-.39062.39062-.39062,1.02344,0,1.41406.19531.19531.45117.29297.70703.29297s.51172-.09766.70703-.29297l9.29297-9.29297v1.58594c0,.55225.44727,1,1,1s1-.44775,1-1v-4c0-.55225-.44727-1-1-1Z"
                                    />
                                  </svg>
                                </div>
                              </div>
                            )}
                          </button>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </>
      ) : (
        <p>No videos available</p>
      )}
    </div>
  );
};

export default SliderBlock;
